export function NotFoundPage() {
    return (
      <>
        <div className="min-h-full py-36 flex flex-col bg-white">
          <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex-shrink-0 flex justify-center">
              <a href="/" className="inline-flex">
                <span className="sr-only">Galilea</span>
                <img
                  className="h-32 w-auto"
                  src="/svg/imagotipo-galilea-18.svg"
                  alt="Galilea"
                />
              </a>
            </div>
            <div className="py-16">
              <div className="text-center">
                <p className="text-xl font-medium text-purple uppercase tracking-wide">Error 404</p>
                <h1 className="mt-2 text-4xl font-medium tracking-tight sm:text-5xl">No encontramos esta página.</h1>
                <p className="mt-2 text-xl">Lo sentimos, no pudimos encontrar la página que estabas buscando.</p>
                <div className="mt-6">
                  <a href="/" className="text-xl font-medium text-tdark hover:text-purple">
                    Volver a inicio <span aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        </div>
      </>
    )
  }
  